import axios from 'axios'
import { api } from '@/services/config'
import { mixin } from '@/mixins/helper'
import store from '@/store'

const myRequest = {
  namespaced: true,
  state: () => ({
    page: 1,
    perPage: 10,
    totalItems: 0,
    totalPages: 0,
    list: [],
    detail: null,
    choosedFilter: 0,
    search: null,
    order_by: '',
    order_short: 'asc',

    isExtend: false,
    choosedVendor: '',
    nama_vendor: '',
  }),
  mutations: {
    SET_EXTEND(state, payload) {
      state.isExtend = true
      state.choosedVendor = payload.id
      state.nama_vendor = payload.nama_vendor
    },
    CANCEL_EXTEND(state) {
      state.isExtend = false
      state.choosedVendor = ''
      state.nama_vendor = ''
    },
    SET_REQUEST_LIST(state, payload) {
      state.list = payload.value.items
      state.page = mixin.methods.$get(
        payload.value,
        'paginationInformation.page',
        1
      )
      state.perPage = mixin.methods.$get(
        payload.value,
        'paginationInformation.perPage',
        10
      )
      state.totalItems = mixin.methods.$get(
        payload.value,
        'paginationInformation.totalItems',
        0
      )
      state.totalPages = mixin.methods.$get(
        payload.value,
        'paginationInformation.totalPages',
        0
      )
    },
    SET_DATA(state, payload) {
      state[payload.name] = payload.value
    },
    SET_PAGINATION(state, payload) {
      state[payload.name] = payload.value
    },
    SET_ORDER_SHORT(state) {
      if (state.order_short == 'asc') {
        state.order_short = 'desc'
      } else {
        state.order_short = 'asc'
      }
    },
  },
  actions: {
    getRequest: async ({ commit, state, rootState }, payload) => {
      await commit('SET_GLOBAL_LOADING', true, { root: true })

      let query = ''
      if (state.choosedFilter) query += `&status=${state.choosedFilter}`
      if (state.search) query += `&search=${state.search}`

      if (state.order_by) {
        query += `&order_by=${state.order_by}&order_short=${state.order_short}`
      }

      const url = `${api}/api/v1/request/myrequest?page=${
        payload && payload.change ? 1 : state.page
      }&limit=${state.perPage}&user_id=${rootState.userid}${query}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        await commit('SET_REQUEST_LIST', { name: 'list', value: data.data })
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    requestDetail: async ({ commit, state, rootState }, id) => {
      await commit('SET_GLOBAL_LOADING', true, { root: true })
      const url = `${api}/api/v1/request/detailvendor/${id}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        await commit('SET_DATA', { name: 'detail', value: data.data.items[0] })
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    sapDetail: async ({ commit, state, rootState }, id) => {
      await commit('SET_GLOBAL_LOADING', true, { root: true })
      const url = `${api}/api/v1/request/detail/${id}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        await commit('SET_DATA', { name: 'detail', value: data.data.items[0] })
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async setPagination({ commit, dispatch }, payload) {
      await commit('SET_PAGINATION', payload)
      await dispatch('getRequest')
    },
    async approveVendor({ commit }, payload) {
      const url = `${api}/api/v1/request/approve/${payload.id}`
      try {
      } catch (error) {}
    },
    async rejectVendor({ commit }, payload) {
      const url = `${api}/api/v1/request/reject/${payload.id}`
      try {
      } catch (error) {}
    },
    async postpone({ commit }, payload) {
      const url = `${api}/api/v1/request/postpone/${payload.id}`
      try {
      } catch (error) {}
    },
    async createRequest({ commit, state, rootState }, payload) {
      await commit('level1/SET_LOADING', true, { root: true })
      const url = `${api}/api/v1/request`

      let bodyFormData = new FormData()
      bodyFormData.append('type', payload.type)
      bodyFormData.append('user_id', rootState.userid)
      bodyFormData.append('vendor', payload.vendor)
      bodyFormData.append('bisnis_unit', payload.bisnis_unit)
      payload.company_code &&
        bodyFormData.append(
          'company_code',
          payload.company_code ? payload.company_code : ''
        )
      payload.note &&
        bodyFormData.append('note', payload.note ? payload.note : '')
      payload.lampiran &&
        bodyFormData.append(
          'lampiran',
          payload.lampiran ? payload.lampiran : ''
        )

      try {
        const { data } = await axios({
          method: 'POST',
          url,
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        await commit('SET_NOTIF', 'Permintaan anda sedang di proses.', {
          root: true,
        })
        await commit('SET_REQUEST_LIST', { name: 'list', value: data.data })
        await commit('level1/SET_LOADING', false, { root: true })
        await commit('CANCEL_EXTEND')

        payload.type == 2 &&
          (await commit(
            'modalReqApp/SET_VALUE',
            { name: 'modalExtendSap', value: false },
            { root: true }
          ))
        payload.type == 3 &&
          (await commit(
            'modalReqApp/SET_VALUE',
            { name: 'modalBlockVendor', value: false },
            { root: true }
          ))
        payload.type == 4 &&
          (await commit(
            'modalReqApp/SET_VALUE',
            { name: 'modalUnblockVendor', value: false },
            { root: true }
          ))
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('level1/SET_LOADING', false, { root: true })
      }
    },
    async deleteVendor({ commit, state, rootState }, payload) {
      const url = `${api}/api/v1/request/${payload.id}`
      try {
        const { data } = await axios({
          method: 'DELETE',
          url,
          data: {
            note: payload.note,
            user_id: rootState.userid,
          },
        })

        await commit('SET_NOTIF', `${data.status}`, {
          root: true,
        })
        await commit('CANCEL_EXTEND')
        await commit(
          'modalReqApp/SET_VALUE',
          {
            name: 'modalDeleteVendor',
            value: false,
          },
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
  },
}

export default myRequest
